import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DateTime } from 'luxon';

import { TranslateConfigService } from '@core/translate-config.service';
import { TimeframeEnum } from '@api/index';
import { EnumService } from '@core/services/enum.service';
import { OverviewData, ChartColors, FormatedPeopleDistribution, PeopleTypeData } from '@admin/statistics/statistics.model';
import { objectHasAnyPositiveValue, sumObjects } from '@app/shared/utils/utils';

@Component({
  selector: 'flow-age-gender-distribution-graph',
  templateUrl: './age-gender-distribution-graph.component.html',
  styleUrls: ['./age-gender-distribution-graph.component.scss'],
})
export class AgeGenderDistributionGraphComponent implements OnChanges {
  @Input() data!: OverviewData<FormatedPeopleDistribution, PeopleTypeData>;
  @Input() startDate!: string;
  @Input() endDate!: string;
  @Input() compareStartDate!: string;
  @Input() compareEndDate!: string;
  @Input() compare!: boolean;
  @Input() timeframe!: TimeframeEnum;

  hasData = false;
  weekNumber: number;
  weekNumberCompare: number;
  timeframeType: string = '';
  colors = {
    primary: ChartColors.Primary,
    primaryLight: ChartColors.PrimaryLight,
    primaryDark: ChartColors.PrimaryDark,
    secondary: ChartColors.Secondary,
    secondaryLight: ChartColors.SecondaryLight,
    secondaryDark: ChartColors.SecondaryDark,
    white: ChartColors.White,
  };

  constructor(protected translateConfigService: TranslateConfigService, private enumService: EnumService) {}

  ngOnChanges(changes: SimpleChanges) {
    const currentData = changes?.data?.currentValue;
    const totalsSummed = sumObjects(currentData?.totals, currentData?.totalsCompare);
    const currentDataCompare = currentData?.distributionCompare;

    this.weekNumber = DateTime.fromISO(this.startDate).weekNumber;
    this.weekNumberCompare = DateTime.fromISO(this.compareStartDate).weekNumber;
    this.hasData = objectHasAnyPositiveValue(totalsSummed);

    if (!changes?.timeframe?.currentValue) {
      currentDataCompare && this.setTimeframe();
    }
  }

  setTimeframe() {
    const x = this.timeframe ? this.enumService.timeframeTypes[this.timeframe].name : null;
    this.timeframeType = x && this.translateConfigService.instant(x);
  }
}
